// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3i2p6","actionsCol":"EnrolledClinics_actionsCol__GrLwE"};